/** Notify `ead-chat-panel` to reload after programmatic chat.send (node report, mindmap, etc.). */

export const EAD_RUN_CHAT_UPDATED = "ead-run-chat-updated";

export type RunChatUpdatedDetail = {
  sessionKey: string;
  /** Optimistic user bubble until history poll includes the row. */
  userMessage?: string;
};

export function notifyRunChatUpdated(detail: RunChatUpdatedDetail): void {
  const sessionKey = String(detail.sessionKey || "").trim();
  if (!sessionKey) return;
  window.dispatchEvent(
    new CustomEvent<RunChatUpdatedDetail>(EAD_RUN_CHAT_UPDATED, {
      detail: { ...detail, sessionKey },
    }),
  );
}
